/* Presentation only: preserves Shopify cart IDs, AJAX handlers and checkout URLs. */
(() => {
  'use strict';
  if (window.agFunctionalUXInstalled) return;
  window.agFunctionalUXInstalled = true;
  const installed = new WeakSet();
  const spanish = (document.documentElement.lang || 'es').toLowerCase().startsWith('es');
  let frame = 0;
  const setVar = (el, name, value) => { if (el.style.getPropertyValue(name) !== value) el.style.setProperty(name, value); };
  function fitViewport(root) {
    const viewport = window.visualViewport;
    const top = Math.round(viewport?.offsetTop || 0);
    const height = Math.round(viewport?.height || window.innerHeight);
    const bottom = top + height;
    let availableBottom = bottom;
    // Respect the theme-preview toolbar without hiding it or reading its iframe.
    document.querySelectorAll('#preview-bar-iframe,#shopify-preview-bar-iframe,iframe[id*="preview-bar"],iframe[id*="preview_bar"],[data-shopify-preview-bar]').forEach(el => {
      const rect = el.getBoundingClientRect();
      const style = getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return;
      if (rect.width > window.innerWidth * 0.5 && rect.height > 12 && rect.height < 180 && rect.top >= top && rect.bottom >= bottom - 8) availableBottom = Math.min(availableBottom, rect.top);
    });
    root.toggleAttribute('data-ag-compact-cart', availableBottom - top < 440);
    setVar(root, '--ag-cart-top', top + 'px');
    setVar(root, '--ag-cart-height', Math.max(0, availableBottom - top) + 'px');
  }
  function refreshActions(root) {
    const footer = root.querySelector('#cart-notification-button');
    if (!footer) return;
    const checkout = footer.querySelector('a[href*="/checkout"]');
    const links = footer.querySelector('.cart-notification__links');
    footer.toggleAttribute('data-ag-cart-empty', !checkout);
    if (!links || !checkout) return;
    if (links.firstElementChild !== checkout) links.prepend(checkout);
    if (spanish && checkout.textContent.trim() !== 'Finalizar compra') checkout.textContent = 'Finalizar compra';
    const viewCart = links.querySelector('a.button--secondary');
    if (spanish && viewCart && viewCart.textContent.trim() !== 'Ver carrito') viewCart.textContent = 'Ver carrito';
  }
  function attach(root) {
    if (!installed.has(root)) {
      installed.add(root);
      // A dedicated inner layout leaves the theme's show/hide display intact.
      let layout = root.querySelector(':scope > .ag-cart-layout');
      if (!layout) {
        layout = document.createElement('div');
        layout.className = 'ag-cart-layout';
        Array.from(root.children).filter(node => !node.classList.contains('preloader')).forEach(node => layout.append(node));
        root.prepend(layout);
      }
      let scroll = layout.querySelector(':scope > .ag-cart-scroll');
      if (!scroll) {
        scroll = document.createElement('div');
        scroll.className = 'ag-cart-scroll';
        scroll.tabIndex = 0;
        scroll.setAttribute('role', 'region');
        scroll.setAttribute('aria-label', spanish ? 'Productos en tu carrito' : 'Products in your cart');
        const first = layout.querySelector(':scope > .slimScrollDiv, :scope > #cart-notification-product');
        layout.insertBefore(scroll, first || layout.querySelector('#cart-notification-button'));
        [':scope > .slimScrollDiv', ':scope > #cart-notification-product', ':scope > .cart-upsell-shipping-inner'].forEach(selector => {
          const node = layout.querySelector(selector);
          if (node) scroll.append(node);
        });
      }
      root.classList.add('ag-cart-ready');
      const observer = new MutationObserver(schedule);
      observer.observe(root, {childList:true, subtree:true});
      root.addEventListener('transitionend', schedule);
    }
    refreshActions(root);
    fitViewport(root);
  }
  function refresh() {
    frame = 0;
    document.querySelectorAll('#cart-notification').forEach(attach);
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(refresh); }
  window.addEventListener('resize', schedule, {passive:true});
  window.visualViewport?.addEventListener('resize', schedule, {passive:true});
  window.visualViewport?.addEventListener('scroll', schedule, {passive:true});
  document.addEventListener('shopify:section:load', schedule);
  const start = () => {
    refresh();
    new MutationObserver(schedule).observe(document.body, {childList:true});
    window.setTimeout(schedule, 1200);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
